// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { Document } from "le-coffre-resources/dist/SuperAdmin";
import type { ApiPayload, QueryPayload } from "../../../types";
import type { IGetDocumentsparams, IPutDocumentsParams } from "./Documents";
import {
	createGetMethod,
	createPostMethod,
	createGetByUidMethod,
	createPutMethod,
	createDeleteMethod,
} from "./helpers/documentsMethodsHelpers";

interface DocumentsInstance {
	get(q: IGetDocumentsparams): Promise<Document[]>;
	post(body: ApiPayload): Promise<Document>;
	getByUid(uid: string, q?: QueryPayload): Promise<Document>;
	put(uid: string, body: IPutDocumentsParams): Promise<Document>;
	delete(uid: string): Promise<Document>;
}

// Module-level singleton instance
let instance: DocumentsInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createDocuments(): DocumentsInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}

	const baseAdmin = baseAdminInstance;
	const baseUrl = baseAdmin.namespaceUrl.concat("/documents");

	return {
		get: createGetMethod(baseAdmin, baseUrl),
		post: createPostMethod(baseAdmin, baseUrl),
		getByUid: createGetByUidMethod(baseAdmin, baseUrl),
		put: createPutMethod(baseAdmin, baseUrl),
		delete: createDeleteMethod(baseAdmin, baseUrl),
	};
}

export function getDocumentsInstance(): DocumentsInstance {
	if (!instance) {
		instance = createDocuments();
	}
	return instance;
}
